import { USERS_ACTIONS } from 'Actions/index';
import { DATA_LOAD_STATUS, PAGE_ACTIONS } from 'Utils/constants';

const initialState = {
  contentStatus: {
    syncInProgress: true,
    data: DATA_LOAD_STATUS.LOADING,
  },
  users: [{}, {}, {}, {}, {}, {}, {}, {}],
  searchMode: false,
  currentAction: PAGE_ACTIONS.VIEW,
  currentSelection: null,
  currentPage: 1,
  totalPages: 1,
  hasNextPage: false,
  hasPrevPage: false,
};

const {
  SET_USERS,
  SELECT_USER,
  SET_USERS_DATA_LOADING,
  SET_USER_CURRENT_ACTION,
} = USERS_ACTIONS;

const employees = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return {
        ...state,
        contentStatus: {
          ...state.contentStatus,
          data: DATA_LOAD_STATUS.LOADED,
        },
        users: action.payload.docs,
        currentSelection: action.payload.docs[0]
          ? action.payload.docs[0]['customerId']
          : null,
        currentAction: action.payload.docs[0]
          ? PAGE_ACTIONS.VIEW
          : PAGE_ACTIONS.NO_RESULTS,
        currentPage: action.payload.page,
        totalPages: action.payload.totalPages,
        hasNextPage: action.payload.hasNextPage,
        hasPrevPage: action.payload.hasPrevPage,
      };
    case SELECT_USER:
      return {
        ...state,
        currentSelection: action.payload,
      };
    case SET_USERS_DATA_LOADING:
      return {
        ...state,
        contentStatus: {
          ...state.contentStatus,
          data: DATA_LOAD_STATUS.LOADING,
        },
      };
    case SET_USER_CURRENT_ACTION:
      return {
        ...state,
        currentAction:
          !state.currentSelection &&
          state.currentAction !== PAGE_ACTIONS.NO_RESULTS
            ? PAGE_ACTIONS.NO_RESULTS
            : action.payload,
      };
    default:
      return state;
  }
};

export default employees;
